import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from '../redux/hooks';
import { JSX } from 'react';
interface Props {
  children: JSX.Element;
  roles?: Array<'customer' | 'admin'>;
}

const ProtectedRoute: React.FC<Props> = ({ children, roles }) => {
  const location = useLocation();
  const { accessToken, role, isAuthChecked } = useSelector(state => state.auth);

  if (!isAuthChecked) return null;
  if (!accessToken) return <Navigate to="/" replace state={{ from: location }} />;
  if (roles && !roles.includes(role!)) return <Navigate to="/" replace />;
  
  return children;
};

export default ProtectedRoute;